import script from "./CarteOtex.vue?vue&type=script&setup=true&lang=js"
export * from "./CarteOtex.vue?vue&type=script&setup=true&lang=js"

import "./CarteOtex.vue?vue&type=style&index=0&id=422ae755&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-422ae755"]])

export default __exports__